module.exports = __webpack_public_path__ + "img/coupon_12.dc85bae2.png";